/**
 * Class description
 *
 * Created: 2019-08-13
 * @author jonas
 */

import {BasicBitmapCountUp} from "../display/BasicBitmapCountUp";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {Elastic, Ease, Linear, TimelineLite, TweenLite, Power3, Power2} from "gsap";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SALayerConfig} from "../../config/SALayerConfig";
import {SATextStyles} from "../../config/SATextStyles";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {SpacierArcadeSoundConfig} from "../SpacierArcadeSoundConfig";

export class CountUpView extends BaseView {
    private _winWays:PIXI.Text;
    private _layer:ScalableLayer;
    private _bitmapText:BasicBitmapCountUp;
    private _soundPlaying:boolean = false;

    constructor() {
        super();
        this._layer = StageManager.getLayer(SALayerConfig.WIN_COUNT_UP.name);
        this.name = "countUpView";
    }


    protected initAnimations():void {
        this._bitmapText = new BasicBitmapCountUp(SATextStyles.WIN_COUNT_UP, 550, new PIXI.Point(0.5, 0.5));
        this._bitmapText.position.set(GameConfig.instance.REEL_AREA_WIDTH * 0.5 + GameConfig.instance.REEL_AREA_POS_X, GameConfig.instance.REEL_AREA_HEIGHT * 0.72 + GameConfig.instance.REEL_AREA_POS_Y);
        this.addChild(this._bitmapText);

        this._winWays = new PIXI.Text(Translation.translate("243 Ways Won"), SATextStyles.WIN_WAYS_TEXT);
        this._winWays.anchor.set(0.5, 0.5);
        this._winWays.position.set(GameConfig.instance.REEL_AREA_WIDTH * 0.5 + GameConfig.instance.REEL_AREA_POS_X, GameConfig.instance.REEL_AREA_HEIGHT * 0.64 + GameConfig.instance.REEL_AREA_POS_Y);
        this._winWays.alpha = 0;

        this.addChild((this._winWays));
    }



    public calculateTextScale(from:number, to:number){
        this._bitmapText.preCalculateScale(from, to);
    }

    public getWinStepAnimation(from:number, to:number, duration:number, ease:Ease = Linear.easeNone):TimelineLite {
        this._bitmapText.preCalculateScale(from, to);
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            () => {
                this._layer.addChild(this);
            },
            this._bitmapText.getCountAnimation(from, to, duration, from == 0 ? Power3.easeInOut : Power2.easeOut),
            () => SlotGame.sound.playEffect(SpacierArcadeSoundConfig.instance.BIG_WIN_COUNTUP, 1000),
            TweenLite.fromTo(this._bitmapText.scale, 1,
                {x : 0.7, y : 0.7},
                {
                    x : 1,
                    y : 1,
                    ease : Elastic.easeOut.config(1.5, 1)
                })

        ], 0);
        return tl;
    }

    public abort(value:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            if(!(this._layer.getChildByName("countUpView"))) {
                this._layer.addChild(this);
            }
        });
        tl.add(() => {
            this._bitmapText.stopAt(value);
            SlotGame.sound.stopEffect(SpacierArcadeSoundConfig.instance.BIG_WIN_COUNTUP);
        });
        return tl;
    }

    public moveCountUp(value:number, displayDuration:number, fadeDuration:number, shouldNotMove:boolean, totalWinWaysWon:number):TimelineLite{
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            let staticText:string = totalWinWaysWon > 1 ? " Ways Won" : " Way Won";
            this._winWays.text = Translation.translate( totalWinWaysWon + staticText);
            this._layer.addChild(this);
            this._bitmapText.stopAt(value);
            SlotGame.winFieldController.showWinField();
        });
        tl.add(new TweenLite(this._bitmapText.position, 0.5, {y: GameConfig.instance.REEL_AREA_HEIGHT * 0.49 + GameConfig.instance.REEL_AREA_POS_Y }), tl.totalDuration() + 0.1);
        tl.add([
            new TweenLite(this._winWays, 0.1, {alpha : 1})
        ]);
        tl.add(() => this.fadeAndRemove(fadeDuration), tl.totalDuration() + displayDuration);
        return tl;
    }


    public end(value:number, displayDuration:number, fadeDuration:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            this._layer.addChild(this);
            this._bitmapText.stopAt(value);
            SlotGame.winFieldController.showWinField();
        });
        tl.add(() => this.fadeAndRemove(fadeDuration), displayDuration);
        return tl;
    }


    private fadeAndRemove(fadeDuration:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite({onComplete: ()=> {
                this._bitmapText.position.y = GameConfig.instance.REEL_AREA_HEIGHT * 0.72 + GameConfig.instance.REEL_AREA_POS_Y;
            }});
        tl.add(new TweenLite(this, fadeDuration, {alpha : 0, ease : Linear.easeNone}));
        tl.add(() => {
            this._layer.removeChild(this);
            this.alpha = 1;
            this._winWays.alpha = 0;
        });
        return tl;
    }
}